class ContentShoppableImages extends HTMLElement {

  constructor() {
    super();
    this.events = ["click"];
    this.addListener();
  }
  
  disconnectedCallback() {
    this.removeListener();
  }
  
  addListener() {
    for (const event of this.events) {
      this.addEventListener(event, this, { capture: true });
    }
  }
  
  removeListener() {
    for (const event of this.events) {
      this.removeEventListener(event, this, { capture: true });
    }
  }
  
  handleEvent(event) {
    const activeElement = this.querySelector('.popover-artikel-oeffnen[data-state="active"]');
    const { type, target } = event;
    switch (type) {
      case "click":
        if (target.classList.contains('popover-artikel-oeffnen')) {
          this.popoverOeffnenHandler(event, activeElement);
        }
        if (activeElement && (target.classList.contains('popover-artikel-schliessen') || !!target.closest('.popover-artikel-schliessen'))) {
          activeElement.removeAttribute('data-state');
        }
        break;
      default:
        break;
    }
  }

  // Overlay öffnen
  popoverOeffnenHandler(event, activeElement) {
    event.preventDefault();
    const { target } = event;
    if(activeElement && activeElement === target) {
      return;
    }
    this.closeOpenDialogs();
    this.setActiveState(target, activeElement);
    this.openDialog(target);
  }

  // Alle Overlays schliessen
  closeOpenDialogs() {
    const openDialogs = this.querySelectorAll('dialog[open]');
    for (const element of openDialogs) {
      element.removeAttribute('show');
      element.close();
    }
  }

  // Aktivstatus geklickter Button
  setActiveState(target, activeElement) {
    if(activeElement) {
      activeElement.removeAttribute('data-state');
    }
    target.dataset['state'] = 'active';
  }

  // Overlay öffnen
  openDialog(target) {
    const listItem = target.closest('.list-item');
    const dialog = listItem.querySelector('dialog');
    dialog.setAttribute('show', '');
    dialog.show();
  }

}

if (!customElements.get("content-shoppable-images")) {
  customElements.define("content-shoppable-images", ContentShoppableImages);
}
